/**
 * Reads back the currency the Nova / baCurr app is currently displaying.
 *
 * The app persists the shopper's choice across page loads on its own and re-applies it
 * before the theme scripts run, but it never writes the choice into `baCurr.config` —
 * `config.user_curr` stays on the shop currency for the whole session. The only reliable
 * signal of what is on screen is the selector label the app renders.
 *
 * So this reads the label rather than tracking clicks: a shopper who picked EUR three
 * pages ago is still on EUR, and only the label knows that.
 *
 * `currency-selector-fix.js` and `currency-price-facet-fix.js` both read from here.
 */
window.DefactoCurrency = (function () {
  var SELECTOR_ROOT = '.bacurr-cur-block';
  var LABEL = '.bacurr-choiceDesign .ba-chosen';
  var ISO_CODE = /^[A-Z]{3}$/;

  var current = null;
  var listeners = [];

  function labelCode() {
    var node = document.querySelector(LABEL);
    var text = node && node.textContent.trim();
    return ISO_CODE.test(text) ? text : null;
  }

  function sync() {
    var code = labelCode();
    if (!code || code === current) return;
    current = code;
    listeners.forEach(function (listener) {
      listener(code);
    });
  }

  // The app replaces the whole selector block when it re-renders, so watch the container
  // rather than the label node itself.
  function watch() {
    var root = document.querySelector(SELECTOR_ROOT) || document.body;
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, characterData: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  // The selector arrives asynchronously with the app embed; keep looking until it does.
  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    sync();
    if (current || attempts > 40) clearInterval(timer);
  }, 250);

  return {
    shop: function () {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    },

    // What the app is displaying right now, falling back to the shop currency before the
    // selector has rendered.
    display: function () {
      return current || this.shop();
    },

    // Null only while the selector has not rendered yet.
    selected: function () {
      return current;
    },

    onChange: function (listener) {
      listeners.push(listener);
    },

    canConvert: function () {
      return !!(window.baCurr && window.baCurr.Currency && typeof window.baCurr.Currency.convert === 'function');
    },

    convert: function (amount, from, to) {
      if (from === to || !this.canConvert()) return amount;
      var converted = window.baCurr.Currency.convert(amount, from, to);
      return isNaN(converted) ? amount : converted;
    },

    symbolFor: function (code) {
      try {
        var symbol = new Intl.NumberFormat(undefined, { style: 'currency', currency: code })
          .formatToParts(0)
          .find(function (part) {
            return part.type === 'currency';
          });
        return symbol ? symbol.value : code;
      } catch (e) {
        return code;
      }
    },
  };
})();
